<div class="inbox-datatable__main-content scrollable-component">
	<ag-grid-angular
		#grid class="ag-theme-balham"
		[enableCellTextSelection]="true"
		(gridReady)="onInitializeGrid($event)"
		(gridSizeChanged)="resizeToFitColumns()"
		[pagination]="false"
		[suppressPaginationPanel]="true"
		[gridOptions]="gridOptions"
		[domLayout]="'autoHeight'"
		[rowClassRules]="rowClassRules"
		[rowData]="gridData"
		(selectionChanged)="onSelectionChanged()"
	>
	</ag-grid-angular>
</div>
